import React from "react";
import { Sparkles } from "lucide-react";
import { fmtWhen } from "./labels";

const FIT_LABELS = {
  destinos: { igual: "Mismos destinos", ampliado: "Más destinos/etapas", reducido: "Menos destinos/etapas", cambiado: "Destinos distintos" },
  duracion: { igual: "Misma duración", mas_larga: "Más días", mas_corta: "Menos días" },
  fechas: { iguales: "Mismas fechas", movidas: "Fechas movidas" },
  viajeros: { igual: "Mismos viajeros", cambiado: "Cambió el grupo" },
  nivel: { igual: "Mismo nivel de alojamiento", subido: "Nivel más alto", bajado: "Nivel más bajo" },
  presupuesto: { dentro: "Dentro del presupuesto", por_encima: "Hasta un 25 % por encima", muy_por_encima: "Más de un 25 % por encima", por_debajo: "Por debajo", sin_presupuesto: "Sin presupuesto claro" },
  quien_pidio_cambios: { viajero: "cambios pedidos por el viajero", agente: "cambios propuestos por la agente", ambos: "cambios de ambos", nadie: "sin cambios" },
};
const CLOSE = { reserva: "Reservó", silencio_viajero: "El viajero dejó de responder", rechazo_explicito: "Rechazo explícito", silencio_agente: "Nosotros dejamos de responder", aplazado: "Aplazado / cambio de planes", otro: "Otro" };
const TONE = { cercano: "cercano", neutro: "neutro", comercial: "comercial", frio: "frío" };

/* The per-lead «Patrones» reading: what changed between request and last proposal, and the conversation milestones. */
export function PatternCard({ pattern, patternLabels }) {
  if (!pattern) return null;
  const fit = pattern.fit || {};
  const chips = ["destinos", "duracion", "fechas", "viajeros", "nivel", "presupuesto"].map((k) => ({ k, v: fit[k], label: FIT_LABELS[k]?.[fit[k]] })).filter((c) => c.label);
  const changed = (c) => !["igual", "iguales", "dentro"].includes(c.v);
  return (
    <section className="border border-clay-300 bg-white p-5" data-testid="kimkim-pattern-card">
      <div className="smallcaps flex items-center gap-1.5"><Sparkles size={11}/> Lectura para «Patrones»</div>
      <h2 className="font-serif text-2xl mt-1 mb-3">Lo pedido frente a lo propuesto</h2>
      {pattern.summary && <p className="text-sm text-clay-800 mb-3">{pattern.summary}</p>}
      <div className="flex flex-wrap gap-1.5 mb-3" data-testid="kimkim-pattern-fit">
        {chips.map((c) => (
          <span key={c.k} className={`text-[11px] px-2 py-0.5 border ${changed(c) ? "border-terracotta/50 bg-terracotta/10 text-clay-900" : "border-clay-200 text-clay-600"}`}>{c.label}</span>
        ))}
        {fit.quien_pidio_cambios && <span className="text-[11px] px-2 py-0.5 text-clay-500">· {FIT_LABELS.quien_pidio_cambios[fit.quien_pidio_cambios]}</span>}
      </div>
      {fit.cambios?.length > 0 && (
        <ul className="text-[12px] text-clay-700 list-disc pl-5 space-y-0.5 mb-4">{fit.cambios.map((c, i) => <li key={i}>{c}</li>)}</ul>
      )}
      {pattern.key_factor && <div className="border-l-4 border-terracotta pl-3 py-1 text-sm mb-4"><span className="smallcaps block mb-0.5">Lo que más pesó</span>{pattern.key_factor}</div>}
      {pattern.hitos?.length > 0 && (
        <div className="mb-3">
          <div className="smallcaps mb-2">Hitos de la conversación</div>
          <ol className="relative border-l border-clay-300 ml-2 space-y-2" data-testid="kimkim-pattern-hitos">
            {pattern.hitos.map((h, i) => (
              <li key={i} className="ml-4">
                <span className={`absolute -left-[5px] mt-1.5 h-2 w-2 ${h.quien === "agente" ? "bg-clay-700" : "bg-terracotta"}`}/>
                <div className="text-[11px] text-clay-500 tabular">{h.cuando || "—"} · {h.quien === "agente" ? "nosotros" : "viajero"} · {h.tipo.replace("_", " ")}</div>
                <div className="text-[12px]">{h.texto}</div>
              </li>
            ))}
          </ol>
        </div>
      )}
      <div className="flex flex-wrap gap-1.5 text-[11px] text-clay-600" data-testid="kimkim-pattern-tags">
        {(pattern.patterns || []).map((p) => <span key={p} className="border border-clay-200 px-1.5 py-0.5">{patternLabels?.[p] || p}</span>)}
      </div>
      <div className="text-[11px] text-clay-500 mt-3">Tono {TONE[pattern.tone] || "—"} · {CLOSE[pattern.close] || "—"} · leído {fmtWhen(pattern.at)} · {pattern.model}</div>
    </section>
  );
}
